// extracted by mini-css-extract-plugin
export default {"non-ideal-state":"NoSubscriptions_non-ideal-state__e-7sq"};